SkipWinsButton = {};

SkipWinsButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addSkipWinPlatformEnabledFlag(button);

  button.canEnable = function () {
    return gameController.canSkipWin && !this._flags.modal.active && this._flags.skipWinPlatformEnabled;
  };

  button.canShow = function () {
    return gameController.canSkipWin && !this._flags.modal.active && this._flags.skipWinPlatformEnabled;
  };

  button.onPressedCallback = function () {
    resourceManager.getController("inputOverlord").disableAll();

    gameController.skipWin();

    if (button.soundName !== "") button.playSound();
  };

  return button;
};

SkipWinsButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
};
SkipWinsButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "SkipWinsButton",
  SkipWinsButton.create,
  SkipWinsButton.initialise,
  SkipWinsButton.getFilesRequired
);
